import { appApiSlice } from 'src/api/app-ApiSlice';
import { GetRoomTypesResponse } from 'src/model/api/v2/data-contracts';

export const roomTypeV2ApiSlice = appApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getRoomTypes: builder.query<GetRoomTypesResponse, { isTranslated: boolean, excludeUnassigned: boolean}>({
            query: ({isTranslated, excludeUnassigned}) =>
                `v2/room-type/get-room-types?isTranslated=${isTranslated}&excludeUnassigned=${excludeUnassigned}`,
        }),
    }),
    overrideExisting: false
});

export const {
    useGetRoomTypesQuery,
} = roomTypeV2ApiSlice;
